import { render, staticRenderFns } from "./GoodsCard.vue?vue&type=template&id=0bdb40e4&scoped=true&"
import script from "./GoodsCard.vue?vue&type=script&lang=js&"
export * from "./GoodsCard.vue?vue&type=script&lang=js&"
import style0 from "./GoodsCard.vue?vue&type=style&index=0&id=0bdb40e4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bdb40e4",
  null
  
)

component.options.__file = "src/components/goods-card/GoodsCard.vue"
export default component.exports